import { GoingWorkflow } from "../models/goingWorkflowModel";
import { readFileAsArrayBuffer } from "../Utils";
import { backendRequest } from "./backendApi";
import exceptionService from "./exceptionService";
const log = (e: any, c: string, u?: string) => exceptionService.logError(e, c, u);
const update = async (path: string, body: any, context: string, userId?: string) => {
  const r = await backendRequest<boolean>(path, body);
  if (r.error) log(r.error, context, userId);
  return r.data === true;
};
const GoingWorkflowService = {
  async fetchWorkflow(userId: string): Promise<GoingWorkflow[]> {
    const r = await backendRequest<GoingWorkflow[]>("/going-workflows/list");
    if (r.error) log(r.error, "GoingWorkflowService.fetchWorkflow", userId);
    return r.data ?? [];
  },
  async fetchCurrentQue(hostId: number): Promise<any> {
    const r = await backendRequest<number>("/going-workflows/current-queue", { hostId });
    if (r.error) log(r.error, "GoingWorkflowService.fetchCurrentQue");
    return r.data ?? -1;
  },
  async checkHostWorkflows(hostId: number): Promise<any> {
    const r = await backendRequest("/going-workflows/check-host", { hostId });
    if (r.error) log(r.error, "GoingWorkflowService.checkHostWorkflows");
    return r.error ? -1 : r.data;
  },
  async insertWorkflow(workflow: GoingWorkflow): Promise<any> {
    const r = await backendRequest<number>("/going-workflows/insert", { workflow });
    if (r.error) log(r.error, "GoingWorkflowService.insertWorkflow");
    return r.data ?? false;
  },
  async confirmDoorLocked(workflowId: number, userId: string): Promise<Boolean> {
    return update(
      "/going-workflows/confirm-door-locked",
      { workflowId },
      "GoingWorkflowService.confirmDoorLocked",
      userId
    );
  },
  async startVisit(workflowId: number, userId: string): Promise<Boolean> {
    return update(
      "/going-workflows/start-visit",
      { workflowId },
      "GoingWorkflowService.startVisit",
      userId
    );
  },
  async requestAdditionalTime(workflowId: number, n: number, userId: string): Promise<Boolean> {
    return update(
      "/going-workflows/request-additional-time",
      { workflowId, additionalTimeRequested: n },
      "GoingWorkflowService.requestAdditionalTime",
      userId
    );
  },
  async endVisit(
    workflowId: number,
    picture: any,
    userId: string,
    saving: boolean,
    abandoned: boolean
  ): Promise<Boolean> {
    let value = picture?.uri ?? picture ?? null;
    if (saving && value) {
      const blob = await (await fetch(value)).blob();
      const upload = await backendRequest<string>(
        `/going-workflows/post-use-picture?workflowId=${workflowId}`,
        (await readFileAsArrayBuffer(blob)) as ArrayBuffer
      );
      if (upload.error) log(upload.error, "GoingWorkflowService.endVisit.uploadPicture", userId);
      else value = upload.data;
    }
    return update(
      "/going-workflows/end-visit",
      { workflowId, postUsePicture: value, isUserAbandoned: abandoned },
      "GoingWorkflowService.endVisit",
      userId
    );
  },
  async rateVisit(
    workflowId: number,
    ratingValue: number,
    userId: string,
    hostId: number,
    note?: string
  ): Promise<Boolean> {
    return update(
      "/going-workflows/rate",
      { workflowId, ratingValue, hostId, note },
      "GoingWorkflowService.rateVisit",
      userId
    );
  },
  async fetchUserGoingActivity(userId?: string): Promise<{ data: any; error: any }> {
    const r = await backendRequest("/going-workflows/activity");
    if (r.error) log(r.error, "GoingWorkflowService.fetchUserGoingActivity", userId);
    return r;
  },
  async clearLocationWorkflows(hostId: number): Promise<Boolean> {
    return update(
      "/going-workflows/clear-location",
      { hostId },
      "GoingWorkflowService.clearLocationWorkflows"
    );
  },
};
export default GoingWorkflowService;
